import { z } from 'zod';
import {
    MaterialPayloadDiscriminatedSchema,
    MaterialPayloadPartialDiscriminatedSchema,
} from './mappings/material-payload.ts';
import {
    MATERIAL_PRODUCT_CATEGORY_SCHEMA,
    MATERIAL_PRODUCT_TYPES_SCHEMA,
    MATERIAL_QUOTE_STATUS_SCHEMA,
    MATERIAL_SUPPORTED_UNITS_SCHEMA,
} from './mappings/material-types.ts';
import { IsoDatetimeRangeSchema } from '../date/date.ts';

const AbstractMaterialQuoteBaseSchema = z.object({
    orderId: z.string().uuid(),
    orderProductGroupId: z.string().uuid(),
    orderProductId: z.string().uuid(),
    positionProductId: z.string().uuid().nullable(),
    // product information
    purchaseQuantity: z.number(),
    salesQuantity: z.number(),
    purchaseUnit: MATERIAL_SUPPORTED_UNITS_SCHEMA,
    salesUnit: MATERIAL_SUPPORTED_UNITS_SCHEMA,
    serviceDate: IsoDatetimeRangeSchema,
    productCategory: MATERIAL_PRODUCT_CATEGORY_SCHEMA,
    productType: MATERIAL_PRODUCT_TYPES_SCHEMA,
    // payment information
    partnerOrganizationId: z.number().int().positive(),
    orderingOrganizationId: z.number().int().positive(),
    platformOrganizationId: z.number().int().positive(),
    purchasePrice: z.number(),
    purchaseTaxClassId: z.string().nonempty(),
    salesPrice: z.number(),
    salesTaxClassId: z.string().nonempty(),
    currencyCode: z.string().nonempty(),
    projectPositionNumber: z.string().nonempty().optional(),
    costCenter: z.string().nonempty().optional(),
    requires: z.array(z.string().uuid()),
    requiredBy: z.array(z.string().uuid()),
});

export const BaseMaterialQuoteSchema = AbstractMaterialQuoteBaseSchema.and(MaterialPayloadDiscriminatedSchema);

export const BaseMaterialQuoteSchemaPartial = AbstractMaterialQuoteBaseSchema.partial().and(
    MaterialPayloadPartialDiscriminatedSchema
);

export const MaterialControlPropertiesSchema = z.object({
    id: z.string(),
    status: MATERIAL_QUOTE_STATUS_SCHEMA,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
